/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Repeater — Repeat Text N Times | Toolverse`)
};

const es_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto — Repetir Texto N Veces | Toolverse`)
};

const de_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textwiederholer — Text N-mal wiederholen | Toolverse`)
};

const nl_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstherhaler — Tekst N Keer Herhalen | Toolverse`)
};

const fr_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéteur de texte — Répéter le texte N fois | Toolverse`)
};

const it_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetitore di testo — Ripeti il testo N volte | Toolverse`)
};

const pt_br2_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto — Repetir Texto N Vezes | Toolverse`)
};

const pt_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto — Repetir Texto N Vezes | Toolverse`)
};

const ja_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストリピーター — テキストをN回繰り返す | Toolverse`)
};

const zh_tr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本重复器 — 将文本重复 N 次 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_meta_title", locale)
	if (locale === "en") return en_tr_meta_title(inputs)
	if (locale === "es") return es_tr_meta_title(inputs)
	if (locale === "de") return de_tr_meta_title(inputs)
	if (locale === "nl") return nl_tr_meta_title(inputs)
	if (locale === "fr") return fr_tr_meta_title(inputs)
	if (locale === "it") return it_tr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_tr_meta_title(inputs)
	if (locale === "pt") return pt_tr_meta_title(inputs)
	if (locale === "ja") return ja_tr_meta_title(inputs)
	return zh_tr_meta_title(inputs)
};